import { GymCustomSubdomainHandlerService } from '../support/gym-custom-subdomain-handler.service';

export const gymSubdomainLoaderInitializer = (
  gymCustomSubdomainHandlerService: GymCustomSubdomainHandlerService
) => () => gymCustomSubdomainHandlerService.handle();